<template>
  <div v-if="inPreview">
    <div v-if="generatingPreview" class="relative">
      <b-skeleton
        animation="fade"
        width="100%"
        height="60vh"
      />
      <div class="absolute top-0 left-0 w-100 h-100 d-flex justify-center items-center gap-4">
        <b-spinner />
        <span>Generando previsualización</span>
      </div>
    </div>
    <div>
      <iframe
        v-if="!generatingPreview && pdfUrl !== '' && pdfUrl != null"
        class="w-100"
        :src="pdfUrl"
        style="height: 70vh;"
        name="pdfPreviewIframe"
        title="pdfPreviewIframe"
      />
    </div>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="backToForm()"
        color="primary"
      >
        Volver
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
      >
        Crear
      </vs-button>
    </div>
  </div>
  <div v-else>
    <form data-vv-scope="custom-document" autocomplete="off" @submit.prevent>
      <h2 class="mb-10">Acta de fiscalización</h2>
      <h4>Antecedentes generales</h4>
      <div class="row">
        <div class="col-12">
          <sanitary-companies-list
            :danger="errors.has('custom-document.sanitaryCompany')"
            :danger-text="errors.first('custom-document.sanitaryCompany')"
            v-validate="'required'"
            name="sanitaryCompany"
            label="Empresa sanitaria *"
            data-vv-as="empresa sanitaria"
            v-model="formData.sanitaryCompany"
            ref="sanitaryCompany"
            @full-input="setGeneratedData($event)"
          />
        </div>
        <div class="col-12">
          <regions-list
            :danger="errors.has('custom-document.region')"
            :danger-text="errors.first('custom-document.region')"
            v-validate="'required'"
            name="region"
            label="Región *"
            data-vv-as="región"
            v-model="formData.region"
            ref="region"
          />
        </div>
        <div class="col-12">
          <b-form-group label="Localidad *">
            <v-select
              :class="{'v-select-danger': errors.has('custom-document.location')}"
              :state="errors.has('custom-document.location') ? false : null"
              v-validate="'required'"
              data-vv-as="localidad"
              name="location"
              placeholder="Busque o ingrese una nueva localidad"
              :options="locationOptions"
              v-model="formData.location"
              taggable
            >
              <span slot="no-options">No hay localidades para el criterio de búsqueda</span>
            </v-select>
            <div
              v-if="errors.has('custom-document.location')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
                  <span class="span-text-validation">
                    {{ errors.first('custom-document.location') }}
                  </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="RUT *">
            <b-form-input-rut
              id="rut"
              name="rut"
              autocomplete="off"
              data-cy="rut"
              placeholder="12345678-0"
              v-model="formData.rut"
              :state="errors.has('custom-document.rut') ? false : null"
              v-validate="'required|validateRut'"
              data-vv-as="rut"
              truncate-value
            />
            <div
              v-if="errors.has('custom-document.rut')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.rut') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Identificación instalación sanitaria *">
            <b-form-textarea
              class="mb-2"
              :state="errors.has('custom-document.identification') ? false : null"
              name="identification"
              data-cy="identification"
              data-vv-as="identificación instalación sanitaria"
              type="text"
              rows="3"
              v-model="formData.identification"
              maxLength="1000"
              v-validate="'required'"
              @input="() => formData.identification = formData.identification.toUpperCase()"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.identification.length }}/1000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.identification')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.identification') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Dirección/Ubicación instalación *">
            <b-form-textarea
              :state="errors.has('custom-document.address') ? false : null"
              name="address"
              data-cy="address"
              data-vv-as="dir/ubi instalación"
              type="text"
              rows="3"
              v-model="formData.address"
              maxLength="1000"
              v-validate="'required'"
              @input="() => formData.address = formData.address.toUpperCase()"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.address.length }}/1000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.address')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.address') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Nombre responsable empresa *">
            <b-form-textarea
              :state="errors.has('custom-document.sanitaryCompanyLR') ? false : null"
              v-validate="'required'"
              data-vv-as="nombre responsable empresa"
              data-cy="sanitaryCompanyLR"
              name="sanitaryCompanyLR"
              type="text"
              v-model="formData.sanitaryCompanyLR"
              rows="3"
              maxLength="1000"
              @input="() => formData.sanitaryCompanyLR = formData.sanitaryCompanyLR.toUpperCase()"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.sanitaryCompanyLR.length }}/1000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.sanitaryCompanyLR')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.sanitaryCompanyLR') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Fono *">
            <b-form-input
              autocomplete="off"
              placeholder="Utilice el formato +56912345678"
              :state="errors.has('custom-document.phone') ? false : null"
              v-validate="{ required: true, regex: phoneRegex }"
              data-vv-as="fono"
              data-cy="phone"
              name="phone"
              type="text"
              pattern="^[+][0-9]{10,11}$"
              v-model="formData.phone"
            />
            <div
              v-if="errors.has('custom-document.phone')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.phone') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Email *">
            <v-select
              :class="{'v-select-danger': errors.has('custom-document.email')}"
              :state="errors.has('custom-document.email') ? false : null"
              v-validate="'required'"
              data-vv-as="email"
              name="email"
              placeholder="Busque o ingrese un nuevo email"
              :options="emailOptions"
              v-model="formData.email"
              taggable
              multiple
            >
              <span slot="no-options">No hay emails para el criterio de búsqueda</span>
            </v-select>
            <div
              v-if="errors.has('custom-document.email')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.email') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Fecha inicio *">
            <datetime
              class="w-100"
              :input-class="{
                'form-control': true,
                'border-danger': errors.has('custom-document.startDate')
              }"
              placeholder="AAAA-MM-DD"
              v-validate="'required'"
              data-vv-as="fecha inicio"
              data-cy="startDate"
              name="startDate"
              v-model="formData.startDate"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
              format="yyyy-MM-dd"
              @input="setEndDate($event)"
            />
            <div
              v-if="errors.has('custom-document.startDate')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.startDate') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Fecha término *">
            <datetime
              class="w-100"
              :input-class="{
                'form-control': true,
                'border-danger': errors.has('custom-document.endDate')
              }"
              placeholder="AAAA-MM-DD"
              :state="errors.has('custom-document.endDate') ? false : null"
              v-validate="'required'"
              data-vv-as="fecha término"
              data-cy="endDate"
              name="endDate"
              v-model="formData.endDate"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
              format="yyyy-MM-dd"
              :min-datetime="formData.startDate"
            />
            <div
              v-if="errors.has('custom-document.endDate')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.endDate') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Hora inicio *">
            <datetime
              class="w-100"
              :input-class="{
                'form-control': true,
                'border-danger': errors.has('custom-document.startTime')
              }"
              placeholder="HH:MM"
              :state="errors.has('custom-document.startTime') ? false : null"
              v-validate="'required'"
              data-vv-as="hora inicio"
              data-cy="startTime"
              name="startTime"
              v-model="formData.startTime"
              title="Hora inicio"
              type="time"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
            />
            <div
              v-if="errors.has('custom-document.startTime')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.startTime') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 col-12">
          <b-form-group label="Hora término *">
            <datetime
              class="w-100"
              :input-class="{
                'form-control': true,
                'border-danger': errors.has('custom-document.endTime')
              }"
              placeholder="HH:MM"
              :state="errors.has('custom-document.endTime') ? false : null"
              v-validate="'required'"
              data-vv-as="hora término"
              data-cy="endTime"
              name="endTime"
              v-model="formData.endTime"
              title="Hora inicio"
              type="time"
              :phrases="{ok: 'Seleccionar', cancel: 'Cancelar'}"
              value-zone="local"
            />
            <div
              v-if="errors.has('custom-document.endTime')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.endTime') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="col-md-12">
        <vs-divider/>
      </div>
      <h4>Identificación de participantes</h4>
      <div class="row">
        <div class="col-12">
          <b-form-group label="SiSS *">
            <UsersList
              :state="errors.has('custom-document.siss') ? false : null"
              :danger="errors.has('custom-document.siss')"
              :danger-text="errors.first('custom-document.siss')"
              v-validate="{ required: formData.siss.length <= 0 }"
              data-cy="siss"
              data-vv-as="siss"
              placeholder="Busca a un usuario para agregar..."
              :is-clearable="false"
              label=""
              class="w-100 mb-0"
              autocomplete
              name="siss"
              :is-multiple="true"
              v-model="formData.siss"
              @input="setFunctionaries($event)"
            />
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="SANITARIA *">
            <b-form-textarea
              :state="errors.has('custom-document.sanitary') ? false : null"
              name="sanitary"
              data-cy="sanitary"
              data-vv-as="sanitaria"
              type="text"
              rows="3"
              v-model="formData.sanitary"
              maxLength="1000"
              v-validate="'required'"
              @input="() => formData.sanitary = formData.sanitary.toUpperCase()"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.sanitary.length }}/1000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.sanitary')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.sanitary') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="col-md-12">
        <vs-divider/>
      </div>
      <h4>Motivo de la fiscalización</h4>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Motivo de la fiscalización *">
            <b-form-textarea
              :state="errors.has('custom-document.reason') ? false : null"
              name="reason"
              data-cy="reason"
              data-vv-as="motivo fiscalización"
              type="text"
              rows="3"
              v-model="formData.reason"
              maxLength="5000"
              v-validate="'required'"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.reason.length }}/5000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.reason')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.reason') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-12">
          <b-form-group label="Observaciones fiscalización / situaciones constatadas *">
            <b-form-textarea
              :state="errors.has('custom-document.reason') ? false : null"
              name="observations"
              data-cy="observations"
              data-vv-as="obs. fiscalización/sit. constatadas"
              type="text"
              rows="3"
              v-model="formData.observations"
              v-validate="'required'"
              maxLength="16000"
            />
            <div class="text-right">
              <small v-tooltip="'Contador de caracteres'">
                {{ formData.observations.length }}/16000
              </small>
            </div>
            <div
              v-if="errors.has('custom-document.observations')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('custom-document.observations') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div
        v-if="!!error.message"
        class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-right"
      >
        <span class="span-text-validation">
          {{ error.message }}
        </span>
      </div>
      <div>
        <div class="row align-items-center mt-5">
          <div class="col-md-12">
            <label>Adjuntar documentos</label>
          </div>
          <div class="col-md-3 align-items-end">
            <UploadFile
              permission="*"
              accept="application/pdf, .doc, .docx, .xlsx, .ppt"
              text="Seleccionar documentos"
              v-model="fileOthers"
              upload-to="ed"
              :button-class="{ 'btn-block': true,
                 'mb-5': errors.has('custom-document.fileName') }"
              container-class="w-100"
              @input="addOthersFile()"
            />
          </div>
          <div class="col-3" v-for="file in formData.attachments" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="45px" color="primary" />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                @click="removeOthersFile(file.id)"
              />
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-if="!!error.messageOthers"
              class="con-text-validation span-text-validation-danger
              vs-input--text-validation-span v-enter-to text-left"
            >
          <span class="span-text-validation">
            {{ error.messageOthers }}
          </span>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row justify-end">
      <vs-button
        class="mt-5 mr-5"
        data-cy="cancel"
        @click="back()"
        color="primary"
        :disabled="saving"
      >
        Cancelar
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="preview"
        @click="preview()"
        color="warning"
        :disabled="saving"
      >
        Previsualizar
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
      <vs-button
        class="mt-5 mr-5"
        data-cy="save"
        @click="save()"
        color="success"
        :disabled="saving"
      >
        Crear
        <span
          v-show="saving"
          class="spinner-border spinner-border-sm text-primary"
        />
      </vs-button>
    </div>
  </div>
</template>

<script>

import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import { mapGetters } from 'vuex';

import { ioCreateCustomDocument, ioGetCustomDocument } from '@/febos/servicios/api/customDocuments.api';
import BFormInputRut from '@/components/inputs/BFormInputRut';
import SanitaryCompaniesList
from '@/febos/global/customDocuments/vistas/empresas/61221000-4/components/SanitaryCompaniesList';
import RegionsList from '@/febos/global/customDocuments/vistas/empresas/61221000-4/components/RegionsList';
import UsersList from '@/febos/global/customDocuments/vistas/empresas/61221000-4/components/UsersList';
import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  name: 'AF',
  components: {
    UploadFile,
    UsersList,
    RegionsList,
    SanitaryCompaniesList,
    BFormInputRut,
  },
  data() {
    return {
      formData: {
        sanitaryCompany: '',
        region: '',
        location: '',
        rut: '',
        identification: '',
        address: '',
        sanitaryCompanyLR: '',
        phone: '',
        email: '',
        startDate: new Date().toISOString(),
        endDate: new Date().toISOString(),
        startTime: '',
        endTime: '',
        siss: '',
        sanitary: '',
        reason: '',
        observations: '',
        attachments: []
      },
      fileOthers: {},
      locationOptions: [],
      emailOptions: [],
      saving: false,
      file: {},
      error: {
        message: ''
      },
      phoneRegex: /^[+][0-9]{10,11}$/,
      inPreview: false,
      generatingPreview: false,
      pdfUrl: '',
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
  },
  methods: {
    back() {
      /* eslint-disable no-restricted-globals */
      history.back();
    },
    backToForm() {
      this.inPreview = false;
    },
    async addOthersFile() {
      if (!Object.keys(this.fileOthers).length) {
        return;
      }

      if (this.fileOthers.failed) {
        this.error.messageOthers = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.formData.attachments.push(this.fileOthers);
      this.error.messageOthers = '';
    },
    removeOthersFile(fileId) {
      this.formData.attachments = this.formData.attachments
        .filter((file) => file.id !== fileId);
    },
    setFunctionaries(event) {
      this.formData.siss = '';
      if (event && event.length > 0) {
        this.formData.siss = event.map((functionary) => functionary.label).join(', ');
      }
      console.log(this.$route.query);
    },
    setGeneratedData(event) {
      this.formData.rut = '';
      this.formData.email = '';
      this.formData.location = '';
      this.emailOptions = [];
      this.locationOptions = [];

      if (event && event.extra) {
        const { rut, correos, localidades } = event.extra;

        this.formData.rut = rut || '';
        this.emailOptions = correos && correos.length > 0 ? correos.split(',') : [];
        this.locationOptions = localidades && localidades.length > 0
          ? localidades.map((localidad) => localidad.nombre) : [];

        if (this.locationOptions.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          this.formData.location = this.locationOptions[0];
        }

        if (this.emailOptions.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          this.formData.email = [this.emailOptions[0]];
        }
      }
    },
    setEndDate(startDate) {
      this.formData.endDate = startDate;
    },
    async generatePdf(id) {
      this.$bvToast.toast(
        'Generando archivo PDF',
        {
          title: 'En camino...',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await ioGetCustomDocument('AF', id, { pdf: 'si' });
      this.$bvToast.toast(
        'Archivo generado',
        {
          title: 'Listo!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 2000
        }
      );
      window.open(response.data.pdf, '_blank');
      this.back();
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async preview() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }

      this.pdfUrl = '';

      this.inPreview = true;
      this.generatingPreview = true;

      try {
        this.$bvToast.toast(
          'Generando previsualización',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 3000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: {
            ...this.$route.query,
            simular: 'si',
          },
          formData: {
            ...this.formData,
            borrador: true,
          }
        };

        const { data: { pdf } } = await ioCreateCustomDocument(payload);

        if (!pdf || pdf === '') {
          this.$bvToast.toast(
            'Ups!',
            {
              title: 'No se pudo generar la previsualización',
              variant: 'warning',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 5000
            }
          );
          this.backToForm();
        }

        this.pdfUrl = `${pdf}#toolbar=0&navpanes=0&scrollbar=0`;
      } finally {
        this.generatingPreview = false;
      }
    },
    async save() {
      const isValid = await this.validateForm('custom-document');
      if (!isValid) {
        return;
      }

      this.error.message = '';
      this.saving = true;

      try {
        this.$bvToast.toast(
          'Guardando documento',
          {
            title: 'En camino...',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 2000
          }
        );
        const payload = {
          type: this.$route.params.type,
          query: { ...this.$route.query },
          formData: {
            ...this.formData
          }
        };
        const response = await ioCreateCustomDocument(payload);
        await this.generatePdf(response.data.document.id);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
